export const SiteFeatureConfigSymbol = Symbol('SiteFeatureConfig')
export const PageFeatureConfigSymbol = Symbol('PageFeatureConfig')
export const MasterPageFeatureConfigSymbol = Symbol('MasterPageFeatureConfig')
export const FeatureStateSymbol = Symbol('FeatureState')
